import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

import { Navigation } from "./components/navigation";
import { Footer } from "./components/footer";
import ScrollToTop from "./ScrollToTop";
import HomePage from "./components/homePage";
import OtiProductsPage from "./pages/otiProductsPage";
import ScrollToTopButton from "./components/ScrollToTopButton";
import TahilProductsPage from "./pages/tahilProductsPage";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Navigation />

      <Routes>
        <Route
          path="/"
          element={<HomePage data={landingPageData} />}
        />
        {/* <Route path="/flours" element={<FloursPage data={landingPageData.Flours} />} /> */}
        <Route path="/otifoods" element={<OtiProductsPage />} />
        <Route path="/tahilfoods" element={<TahilProductsPage />} />
        {/* <Route path="/pastas" element={<PastasPage data={landingPageData.Pastas}/>} /> */}
        {/* <Route path="/oils" element={<OilsPage />} />
        <Route path="/confectionery" element={<ConfectioneryPage />} /> */}
      </Routes>

      <ScrollToTopButton />
      <Footer />
    </Router>
  );
};

export default App;
